export default __webpack_public_path__ + "static/media/2.fa9ed387.jpg";